export default "__VITE_ASSET__DQMDhcjh__"